module.exports = __webpack_public_path__ + "img/menu.413688a1.png";